import React from 'react';
import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {EmployeesByCarrierChartState} from '../state';
import {Panel, Spinner} from 'components';
import {t} from 'shared/core';

const EmployeesByCarrierChart = observer(({uiState}) => {
  const {Highcharts, HighchartsReact, chartOptions} = uiState;

  return (
    <Panel>
      <Panel.Header title={t('broker_portal.dashboard.Lives by Insurance Carrier')}/>
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
      />
    </Panel>
  );
});

const ChartSpinner = () => {
  return (
    <Panel>
      <Panel.Header
        title={t('broker_portal.dashboard.Lives by Insurance Carrier')}
        description={t('broker_portal.dashboard.Loading data...')}
      />
      <div className='py3'>
        <Spinner/>
      </div>
    </Panel>
  );
};

export default withState(EmployeesByCarrierChart, EmployeesByCarrierChartState, { spinner: ChartSpinner });
